export const ACCEPT_BID = 'Accept bid'
export const CANCEL_BID = 'Cancel bid'
export const ARCHIVE_BID = 'Archive Bid'
export const UNARCHIVE_BID = 'Unarchive Bid'
export const FETCH_NFTS = 'Fetch NFTs'
export const FETCH_ITEMS = 'Fetch Items'
export const ASSET_CLICK = 'Asset click'
export const LOAD_MORE = 'Load more'
export const INIT_PREVIEW = 'Init Preview'

// Buy with card
export const BUY_ITEM = 'Buy Item'
export const BUY_ITEM_WITH_CARD = 'Buy Item With Card'
export const CLICK_BUY_NFT_WITH_CARD = 'Click on Buy NFT With Card'
export const CLICK_BUY_NFT_WITH_CRYPTO = 'Click on Buy NFT With Crypto'
export const CANCEL_BUY_NFT_WITH_CARD = 'Cancel Buy NFT With Card'
export const CLICK_GO_TO_BUY_NFT_WITH_CARD = 'Click on go to Buy NFT With Card'
export const OPEN_BUY_MANA_MODAL = 'Open BUY MANA modal'
export const CONTINUE_BUY_WITH_CARD_MODAL = 'Click on Continue in Buy With Card Explanation Modal'
export const BACK_BUY_WITH_CARD_MODAL = 'Click on Go Back in Buy With Card Explanation Modal'

export const TOGGLE_PREVIEW_MODE = 'Toggle Preview Mode'
export const UPSERT_LAND_RENTAL = 'Upsert Land Rental'
export const CLAIM_LAND_RENTAL = 'Claim Land Rental'
export const RENT_LAND = 'Rent Land'
export const PURCHASED_CANCELLED = 'Purchase Cancelled'
export const PURCHASED_COMPLETE = 'Purchase Complete'
export const PURCHASED_REFUNDED = 'Purchase Refunded'
export const PURCHASED_FAILED = 'Purchase Failed'
export const PURCHASED_STARTED = 'Purchase Started'
export const BUY = 'Buy'
export const BUY_WITH_CARD = 'Buy With Card'
export const BUY_WITH_CRYPTO = 'Click on buy with crypto'
export const PUBLISH = 'Publish'
export const CANCEL_SALE = 'Cancel Sale'
export const TRANSFER_NFT = 'Transfer NFT'
export const TRANSACTION_FAILED = 'Transaction Failed'
export const TRANSACTION_DROPPED = 'Transaction Dropped'
export const TRANSACTION_FIXED = 'Transaction Fixed'
export const TRANSACTION_REPLACED = 'Transaction Replaced'
export const AUTHORIZE = 'Authorize'
export const UNAUTHORIZE = 'Unauthorize'
export const BID = 'Bid'

// Filters
export const MIN_PRICE_CHANGED = 'Min Price Changed'
export const MAX_PRICE_CHANGED = 'Max Price Changed'
export const MIN_ESTATE_SIZE_CHANGED = 'Min Estate Size Changed'
export const MAX_ESTATE_SIZE_CHANGED = 'Max Estate Size Changed'

// Favorites
export const OPEN_FAVORITES_MODAL = 'Open favorites modal'

// Pick & Unpick items in lists
export const PICK_ITEM = 'Pick Item'
export const UNPICK_ITEM = 'Unpick Item'
export const UNDO_UNPICK_ITEM = 'Undo unpick Item'

// Names
export const BUY_NAME_SUCCESS = 'Buy Name Success'
export const SET_AVATAR_NAME = 'Set Avatar Name'
export const CLICK_CHECKOUT_NAME = 'Click checkout name'

export const CLICK_CLAIM_NEW_NAME = 'Click Claim New Name'
export const BULK_PICK = 'Bulk Pick'

export const CREATE_LIST = 'Create List'
export const UPDATE_LIST = 'Update List'
export const DELETE_LIST = 'Delete List'

export const OPEN_SHARE_LIST_MODAL = 'Open share list modal'
export const SHARE_LIST = 'Share list'
export enum SHARE_LIST_TYPE {
  COPY_LINK = 'Copy link',
  TWITTER = 'Twitter'
}

// Search bar component
export const SEARCH_RESULT = 'Search Result'
export const SEARCH_RESULT_CLICKED = 'Search Result Clicked'
export const SEARCH_ALL = 'Search all results'

// Buy Cross-chain
export const BUY_ITEM_CROSS_CHAIN = 'Buy Item Cross Chain'
export const BUY_ITEM_CROSS_CHAIN_ERROR = 'Buy Item Cross Chain Error'
export const BUY_ITEM_CROSS_CHAIN_TRANSACTION_DENIED = 'Buy Item Cross Chain Transaction Denied'
export const CROSS_CHAIN_TOKEN_SELECTION = 'Cross Chain token selection'
export const CROSS_CHAIN_CHAIN_SELECTION = 'Cross Chain chain selection'
export const ERROR_GETTING_ROUTE = 'Error getting Route'
